<h-price-slider [priceRange]="priceRange" [isExpanded]="isExpanded" (valueChange)="onValueChange($event)">
</h-price-slider>
